export default "__VITE_ASSET__$KYcUbUu__"